import { StyledClickable } from "@insite/mobius/Link";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { linkStyles } from "@store/Themes/common/mixins/link";
import { css } from "styled-components";

export const inlineSeparatorStyles = (
    spacing: string,
    width: string,
    color: string,
    spacingType: "margin" | "padding" = "margin",
) => {
    return css`
        position: relative;
        ${spacingType}-right: calc(${spacing} + ${width});

        &::after {
            content: "";
            position: absolute;
            right: ${spacingType === "padding" ? `calc(${spacing} / 2)` : `calc((-${spacing} / 2) - ${width})`};
            height: 1em;
            width: ${width};
            background-color: ${getColor(color)};
            top: 50%;
            transform: translateY(-50%);
            pointer-events: none;
        }

        &:last-child {
            ${spacingType}-right: 0;

            &::after {
                display: none;
            }
        }
    `;
};

export const lineEllipsisStyles = (lineClamp: number) => {
    return css`
        /* stylelint-disable value-no-vendor-prefix, property-no-vendor-prefix */
        display: -webkit-box;
        overflow: hidden;
        -webkit-line-clamp: ${lineClamp};
        -webkit-box-orient: vertical;
        /* stylelint-enable value-no-vendor-prefix, property-no-vendor-prefix */
    `;
};

export const loadingDotsStyles = () => {
    return css`
        display: inline-block;
        text-align: left;
        font-weight: ${x => x.theme.design.typography.weight.bold};
        min-width: 25px;

        &::after {
            overflow: hidden;
            display: inline-block;
            vertical-align: bottom;
            animation: loadingDots steps(4, end) 900ms infinite 1s;
            content: "\\2026";
            width: 0;
        }
    `;
};

export const loadingDotsKeyFrames = () => {
    return css`
        @keyframes loadingDots {
            to {
                width: 1.25em;
            }
        }
    `;
};

export const typographyInvertColorStyles = (color = "invert", hoverColor = "invert.dark") => {
    return css`
        color: ${getColor(color)};

        ${TypographyStyle} {
            color: inherit;
        }

        ${StyledClickable} {
            ${linkStyles("inherit", hoverColor, true, true)}
        }
    `;
};
